(function () { 
  window.generateProductDescriptionTabs = generateProductDescriptionTabs = function generateTabs() {
    $('.product-tabs__wrap').each(function () {

      var source = this.getAttribute('data-source');
      var $thisTabContainer = $(this);
      var coloredTabs = JSON.parse($('#tab-color-json').html().trim());


      // Create Tabs menu within container
      var $firstStaticTab = $thisTabContainer.find('.product-tabs__tabs .static:first');
      var $firstStaticBody = $thisTabContainer.find('.product-tabs__body .static:first');

      $thisTabContainer.find('.product-tabs__tabs .static').each(function (index, el) {
        var title = el.innerText.trim();
        if (undefined !== coloredTabs[title]) {
          el.classList.add('tab-color-' + coloredTabs[title]);
        }
      });

      var targets = source + ' h4';
      targets += ', ' + source + ' h5';
      targets += ', ' + source + ' h6';

      $(targets).each(function (index) {
        var $this = $(this);
        var title = $this.text().replace(/:.*$/, '');
        var colorId = coloredTabs[title] || 'default';
        var colorClass = '';
        if (colorId) {
          colorClass = 'tab-color-' + colorId;
        }

        // Create desktop tab
        var tab = '<li data-tab="' + index + '" class="' + colorClass + '">' + title + '</li>';
        $firstStaticTab.before(tab);

        // Create mobile tab
        var mobileTab = document.createElement('div');
        mobileTab.innerHTML = title;
        mobileTab.setAttribute('data-tab', index);
        mobileTab.className += ' product-tabs__mobile-tab post-large--hide';
        $firstStaticBody.before(mobileTab);

        // Create tab body
        var tabPane = document.createElement('div');
        tabPane.setAttribute('data-tab', index);
        tabPane.className += ' product-tabs__content';
        $firstStaticBody.before(tabPane);
        // move content from main description to tab body
        $this.nextUntil('h4,h5,h6').appendTo(tabPane);

        // Delete heading from main description
        $this.remove();
      });

      initTabs();
    });
  };

  /*****************************************************
  Tab toggling functionality
  *****************************************************/
  function initTabs() {
    var product_tabs = $('.product-tabs__tabs li');
    var mobile_tabs = $('.product-tabs__mobile-tab');
    var product_tabs_content = $('.product-tabs__content');

    var first_tab = product_tabs.first();
    first_tab.addClass('active');
    mobile_tabs.filter('[data-tab="' + first_tab.data('tab') + '"]').addClass('active');
    product_tabs_content.filter('[data-tab="' + first_tab.data('tab') + '"]').addClass('active');

    product_tabs.on('click', function () {
      var $this = $(this);
      var tab = $this.data('tab');
      var selector = '[data-tab="' + tab + '"]';
      if (!$this.hasClass('active')) {
        product_tabs.filter('.active').removeClass('active');
        product_tabs_content.filter('.active').removeClass('active');
        product_tabs.filter(selector).addClass('active');
        product_tabs_content.filter(selector).addClass('active');
      }
    });

    mobile_tabs.on('click', function () {
      var $this = $(this);
      var tab = $this.data('tab');
      var selector = '[data-tab="' + tab + '"]';
      $this.toggleClass('active');
      product_tabs_content.filter(selector).toggleClass('active');
    });
  }
})();